import api from "../../../api/axios";
import { normalizeText } from "../Helpers";
import Swal from "sweetalert2";

const SOURCE_CONTACTO = "contacto";
const SOURCE_CLIENTE = "cliente";

// =============================================
// LÓGICA PRINCIPAL DE SINCRONIZACIÓN
// =============================================
export const notesHistoricLogic = async (
  contact = [],
  client = [],
  setDifferentNotes,
) => {
  // console.log(contact);
  // console.log(client);

  const notasContact = normalizeText(contact?.notas ?? "");
  const notasClient = normalizeText(client?.notas ?? "");

  const contactEmpty = !notasContact;
  const clientEmpty = !notasClient;

  const notasIguales =
    !contactEmpty && !clientEmpty && notasContact === notasClient;

  const tipoCoincidencia = (() => {
    if (contactEmpty && clientEmpty) return "ambas_vacias";
    if (notasIguales) return "iguales";
    if (!contactEmpty && clientEmpty) return "solo_contacto";
    if (contactEmpty && !clientEmpty) return "solo_cliente";
    return "diferentes";
  })();

  // console.log(`Coincidencia detectada: ${tipoCoincidencia}`);

  let transformObservaciones = [];

  if (["solo_contacto", "solo_cliente", "iguales"].includes(tipoCoincidencia)) {
    const origen =
      tipoCoincidencia === "solo_contacto" || tipoCoincidencia === "iguales"
        ? contact
        : client;

    // console.log(origen, "origen");

    transformObservaciones = normalizarObservaciones(
      origen?.notas || "",
      origen?.date_in,
      origen,
      arrayToStatus,
      contact?.id || 0,
      client?.id || 0,
      tipoCoincidencia === "solo_contacto" || tipoCoincidencia === "iguales"
        ? "contacto"
        : "cliente",
    );
  }
  // console.log(transformObservaciones, "transformObservaciones");

  const historicalObject = {
    contact_id: contact?.id || 0,
    client_id: client?.id || 0,
    lawyer: transformObservaciones?.lawyer || 0,
    user_id: transformObservaciones?.user_id || 0,
    created_by: transformObservaciones?.created_by || 0,
    notas: transformObservaciones?.observations || "",
    case_type: transformObservaciones?.case_type || 0,
    company_id: transformObservaciones?.company_id || 0,
    status: transformObservaciones?.status || 0,
    created_at: transformObservaciones?.created_at || "",
    title: transformObservaciones?.title || "",
    note_type: transformObservaciones?.note_type || "",
  };

  // console.log(historicalObject, "historicalObject");

  switch (tipoCoincidencia) {
    case "ambas_vacias":
      setDifferentNotes([]);
      return false;
    case "iguales": {
      const result = await cleanContactNClientNotes(
        contact?.id,
        client?.id,
        historicalObject,
      );
      console.log(result);
      setDifferentNotes([]);
      return result;
    }
    case "solo_contacto":
    case "solo_cliente":
      const result = await cleanerDesicion(
        historicalObject,
        tipoCoincidencia === "solo_cliente" ? client.id : contact.id,
        tipoCoincidencia,
      );

      // console.log(result);

      setDifferentNotes([]);
      return result;
    case "diferentes":
      setDifferentNotes([
        { cliente: client?.notas || "" },
        { contacto: contact?.notas || "" },
      ]);
      return false;
    default:
      console.warn("Tipo de coincidencia no reconocido");
      return false;
  }
};

export const normalizarObservaciones = (
  observaciones,
  date_in = "",
  dataNoEstructure = {},
  statusNoStructure = {},
  contact_id = 0,
  client_id = 0,
  tipo = "contacto", // 👈 puede ser "contacto" o "cliente"
) => {
  let dataFromNote;

  // console.log(
  //   observaciones,
  //   date_in,
  //   dataNoEstructure,
  //   statusNoStructure,
  //   contact_id,
  //   client_id,
  //   tipo,
  // );

  try {
    // Intentar parsear solo si es string
    const parsed =
      typeof observaciones === "string"
        ? JSON.parse(observaciones)
        : observaciones;

    //  Verificamos que realmente sea un objeto (no string, no array, no null)
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      console.log(`Tiene estructura (${tipo})`);
      dataFromNote = parsed;
    } else {
      throw new Error("Estructura no válida"); // Forzar catch si no es objeto
    }

    return dataFromNote;
  } catch (error) {
    console.log(`Estructura no válida (${tipo}), normalizando datos...`);

    // Buscar el nombre del estado
    // const statusName =
    //   statusNoStructure?.find((option) => option.id === dataNoEstructure.status)
    //     ?.nombre || "Desconocido";

    const statusName = Array.isArray(statusNoStructure)
      ? statusNoStructure.find((o) => o.id === dataNoEstructure.status)?.nombre
      : null || "Desconocido";

    // Campos comunes
    dataFromNote = {
      contact_id,
      client_id,
      lawyer: dataNoEstructure?.lawyers_relation?.id || null,
      created_by: 0,
      user_id: dataNoEstructure?.assigned_relation?.id || null,
      observations: observaciones || "",
      created_at: date_in || dataNoEstructure?.date_in || null,
      company_id: dataNoEstructure?.company_relation?.id || null,
      title: "REGISTRO INICIAL",
    };

    // Campos específicos según tipo
    if (tipo === "contacto") {
      dataFromNote = {
        ...dataFromNote,
        case_type: dataNoEstructure?.types_relation?.id || null,
        status: dataNoEstructure?.status || null,
        status_name: statusName,
      };
    }

    return dataFromNote;
  }
};

// =============================================
// GUARDAR HISTÓRICO
// =============================================
export async function guardarHistorico(data) {
  // console.log("guardarHistorico");
  const formDataHistorical = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    formDataHistorical.append(key, value);
  });

  const response = await api.post(
    `${process.env.REACT_APP_API_URL}/contacts/create_historical`,
    formDataHistorical,
  );

  console.log(response);

  return response.data.historical_created?.id ? true : false;
}

// =============================================
// DECISIÓN SEGÚN QUIÉN TIENE NOTA
// =============================================
export async function cleanerDesicion(historic, id, tipoCoincidencia) {
  // console.log(historic, id, tipoCoincidencia, "cleanerDesicion");

  await guardarHistorico(historic);

  if (tipoCoincidencia === "solo_cliente") {
    return await modificarNotas(id, "", "cliente");
  } else if (tipoCoincidencia === "solo_contacto") {
    return await modificarNotas(id, "", "contacto");
  }
  return false;
}

// =============================================
// Función para limpiar notas del contacto y cliente
// =============================================
export async function cleanContactNClientNotes(contactId, clientId, historic) {
  // console.log("limpiarNotasContactoYCliente");
  // console.log(contactId, clientId, historic);

  // Guarda histórico primero
  const res = await guardarHistorico(historic);
  console.log(res);

  // Limpia notas de ambos simultáneamente
  const [resContacto, resCliente] = await Promise.all([
    modificarNotas(contactId, "", "contacto"),
    modificarNotas(clientId, "", "cliente"),
  ]);

  console.log(resContacto, resCliente);

  return resContacto || resCliente;
}

// =============================================
// FUNCIÓN PRINCIPAL PARA MODIFICAR NOTAS
// =============================================
export async function modificarNotas(id, notas = "", tipo) {
  if (!id) {
    console.warn("No se proporcionó un ID válido");
    return false;
  }

  // console.log(`modificarNotas [${tipo}]`, id, notas);

  const isClient = tipo === "cliente";
  const endpoint = isClient
    ? `${process.env.REACT_APP_API_URL}/users/update_client_from_historical`
    : `${process.env.REACT_APP_API_URL}/contacts/update_contact_from_historical`;

  const payload = isClient
    ? { client_id: id, notas }
    : { contact_id: id, notas };

  try {
    const response = await api.post(endpoint, payload);
    const successFlag = isClient
      ? response?.data?.client_update_from_historical
      : response?.data?.contact_update_from_historical;

    console.log(response, "response");
    // console.log(isClient, "isClient");
    // console.log(successFlag, "successFlag");

    return Number(successFlag) === 1;
  } catch (error) {
    console.error(`Error modificando notas (${tipo}):`, error);
    throw error;
  }
}

export const preguntasClave = [
  "Fecha nacimiento(edad):",
  "Estado Civil:",
  "Hijos a su cargo:",
  "Situación Laboral (Funciones que desempeña en su caso):",
  "¿Alguna Invalidez otorgada o en trámite?:",
  "¿Cobra dependencia o alguna otra pensión? (En caso afirmativo indicar el tipo de pensión):",
  "¿Ha presentado recientemente alguna solicitud?",
  "¿Tiene resolución?",
  "¿En qué fecha le fue comunicada?",
];

export const arrayToStatus = [
  { nombre: "Pte Llamada", id: 0 },
  { nombre: "Llamado", id: 1 },
  { nombre: "Cliente", id: 2 },
  { nombre: "Cancelado", id: 3 },
];

export const contienePreguntasClave = (texto = "") =>
  preguntasClave.some((pregunta) => texto.includes(pregunta));

export const nuevoArrayDeNotas = (observations) => {
  return observations.reduce(
    (acc, item) => {
      if (
        contienePreguntasClave(item.notas) ||
        ["PRIMERA NOTA", "REGISTRO INICIAL"].includes(
          item?.title?.toUpperCase(),
        )
      ) {
        acc.conClave.push(item);
      } else {
        acc.sinClave.push(item);
      }
      return acc;
    },
    { conClave: [], sinClave: [] },
  );
};

export const getClientInfo = (nif, email, phone) => {
  if (email?.email && email?.email?.length) return email;
  if (phone?.phone && phone?.phone?.length) return phone;
  if (nif?.nif && nif?.nif.length) return nif;
  return "";
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// =============================================
// LIMPIAR NOTAS DE CONTACTO Y CLIENTE (EN PARALELO)
// =============================================
export async function limpiarNotasContactoYCliente(
  contactId,
  clientId,
  historic,
) {
  // console.log("limpiarNotasContactoYCliente");
  // console.log(contactId, clientId, historic);

  // Guarda histórico primero
  await guardarHistorico(historic);

  // Limpia notas de ambos simultáneamente
  const [resContacto, resCliente] = await Promise.all([
    modificarNotas(contactId, "", "contacto"),
    modificarNotas(clientId, "", "cliente"),
  ]);

  console.log(resContacto, resCliente);

  return resContacto && resCliente;
}

// Limpia notas del contacto
export async function limpiarNotasContacto(id) {
  if (!id) return console.warn("No se proporcionó id de cliente");
  // console.log("limpiarNotasContacto", id);
  const newNotesValue = {
    contact_id: id,
    notas: "",
  };

  try {
    const response = await api.post(
      `${process.env.REACT_APP_API_URL}/contacts/update_contact_from_historical`,
      newNotesValue,
    );

    if (Number(response?.data?.contact_update_from_historical) == 1) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error en limpiarNotasCliente:", error);
    throw error;
  }
}

// Limpia notas del cliente
export async function limpiarNotasCliente(id) {
  if (!id) return console.warn("No se proporcionó id de cliente");
  // console.log("limpiarNotasCliente", id);

  try {
    const newNotesValueClient = { client_id: id, notas: "" };
    const response = await api.post(
      `${process.env.REACT_APP_API_URL}/users/update_client_from_historical`,
      newNotesValueClient,
    );

    if (Number(response?.data?.update_client_from_historical) == 1) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error en limpiarNotasCliente:", error);
    throw error;
  }
}

/**
 * Muestra un SweetAlert con contactos duplicados
 */
export const showDuplicateContactsSwal = async ({
  incomingUser = [],
  flags = [],
  origin = window.location.origin,
  onUseContact = () => {},
  incomingSite = "",
}) => {
  // ================== FLAGS ==================
  const flagsHtml = flags
    .map(
      (flag) => `
        <span style="
          display:inline-block;
          padding:4px 10px;
          margin:2px 4px;
          background:#e8f5e9;
          color:#1b5e20;
          border-radius:14px;
          font-size:13px;
          font-weight:600;
        ">
          ${flag}
        </span>
      `,
    )
    .join("");

  // ================== CONTACT CARDS ==================
  const contactsHtml = incomingUser
    .map((user) => {
      const coincidencias = user.coincidencias ?? [];

      const coincidenciasHtml = coincidencias
        .map(
          (c) => `
            <span style="
              display:inline-block;
              padding:3px 8px;
              margin-right:6px;
              background:#e3f2fd;
              color:#0d47a1;
              border-radius:12px;
              font-size:12px;
              font-weight:600;
            ">
              ${c}
            </span>
          `,
        )
        .join("");

      return `
        <div class="contact-duplicate-card" data-id="${user.id}">
          <div class="contact-header">
        <div class="contact-normal-info">
              <div class="contact-coincidences">${coincidenciasHtml}</div>
                <span class="contact-name">${user.name} ${user.surname}</span>
              </div>
              <div class="contact-actions">
                <button class="contact-toggle-info-btn" data-id="${user.id}">
                  Ver información
                  </button>

                <a
                  href="${origin}/${incomingSite}/ver?id=${user.id}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="contact-go-btn"
                >
                  Ir al usuario
                </a>

                <button class="contact-use-btn" data-id="${user.id}">
                  Utilizar información de este usuario
                </button>
              </div>
            </div>
          <div class="contact-details" id="details-${
            user.id
          }" style="display:none;">
            <div><strong>Correo:</strong> ${user.email ?? "-"}</div>
            <div><strong>Teléfono:</strong> ${user.phone ?? "-"}</div>
            <div><strong>Documento:</strong> ${user.nif ?? "-"}</div>
            <div><strong>Ciudad:</strong> ${user.province ?? "-"}</div>
          </div>
        </div>`;
    })
    .join("");

  // ================== SWEETALERT ==================
  const result = await Swal.fire({
    icon: "warning",
    title: "Usuarios duplicados detectados",
    width: 1000,
    html: `
      <div style="text-align:left;font-size:14px;">
        <div style="
          border:1px solid #ffeeba;
          padding:10px;
          border-radius:6px;
          margin-bottom:12px;
        ">
          <strong>Repetidos encontrados:</strong> ${flagsHtml}
        </div>

        <div style="display:flex;flex-direction:column;gap:8px;">
          ${contactsHtml}
        </div>
      </div>
    `,
    showDenyButton: true,
    denyButtonText: "Volver",
    confirmButtonText: "Continuar",
    confirmButtonColor: "#1ab394",
    reverseButtons: true,

    didOpen: () => {
      // TOGGLE INFO
      document.querySelectorAll(".contact-toggle-info-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          const id = btn.dataset.id;
          const details = document.getElementById(`details-${id}`);
          details.style.display =
            details.style.display === "none" ? "block" : "none";
        });
      });

      // UTILIZAR CONTACTO
      document.querySelectorAll(".contact-use-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          const id = btn.dataset.id;
          const selected = incomingUser.find(
            (c) => String(c.id) === String(id),
          );
          onUseContact?.(selected);

          Swal.close();
        });
      });
    },
  });

  return result;
};

export const usarInformacionContacto = (
  user,
  flag,
  setClientData,
  setContactData,
) => {
  if (flag === SOURCE_CONTACTO) {
    const adaptedContact = {
      // ================== TEXTOS ==================
      name: user.name ?? "",
      surname: user.surname ?? "",
      email: user.email ?? "",
      phone: user.phone ?? "",
      address: user.address ?? "",
      postalcode: user.postalcode ?? "",
      nif: "",
      conditions: user.condiciones ?? "",
      observations: user.notas ?? "",
      date_in: user.date_in ?? "",

      // ================== COMPANY ==================
      company: {
        id: user.company_id ?? 0,
        company_name: "Seleccionar", // puedes reemplazar si tienes el nombre
      },

      // ================== ASOCIATION ==================
      asociation: {
        id: user.asociation ?? 0,
        asoc_name: "Seleccionar",
      },

      // ================== CASE TYPE ==================
      cases_type: {
        id: user.case_type ?? 0,
        case_type: "Seleccionar",
      },

      // ================== STATUS ==================
      status: {
        id: user.status ?? 0,
        nombre: "Pte Llamada",
      },

      // ================== PROVINCE ==================
      province: {
        id_provincia: user.province ?? 0,
        provincia: "Seleccionar",
      },

      // ================== LAWYER ==================
      lawyer: {
        id: user.lawyer ?? 0,
        name: "Seleccionar",
        surname: "",
      },

      // ================== ASSIGN TO ==================
      assignTo: {
        id: user.user_id ?? 0,
        name: "Seleccionar",
        surname: "",
      },

      // ================== FIXED ==================
      marketing: user.marketing ?? 0,
      title: "",
    };

    // console.log(adaptedContact);
    setContactData(adaptedContact);
  }

  if (flag === SOURCE_CLIENTE) {
    const adaptedClient = {
      // ================== TEXTOS ==================
      email: user.email ?? "",
      name: user.name ?? "",
      surname: user.surname ?? "",
      address: user.address ?? "",
      postalcode: user.postalcode ?? "",
      document: user.nif ?? "",
      phone: user.phone ?? "",
      observations: user.observations ?? "",

      // ================== LOCATION ==================
      province: {
        id_provincia: user.province_id ?? 0,
        provincia: "Seleccionar",
      },

      // ================== RELACIONES ==================
      company: {
        id: user.company_id ?? 0,
        company_name: "Seleccionar",
      },

      association: {
        id: user.asociation ?? 0,
        asoc_name: "Seleccionar",
      },

      zone: {
        id: user.zone ?? 0,
        zona: "Seleccionar",
      },

      status: {
        id: user.status ?? -1,
        nombre: "Seleccionar",
      },

      office: {
        id: user.office_id ?? 0,
        office_name: "Seleccionar",
      },

      lawyer: {
        id: user.lawyer ?? 0,
        name: "Seleccionar",
        surname: "",
      },

      // ================== EXTRAS ==================
      cards: user.cards ?? [],
    };

    // console.log(adaptedClient);
    setClientData(adaptedClient);
  }
};

export const buscarDuplicados = async ({
  baseUrl,
  queryParams,
  currentId,
  setData,
  incomingSite, // "clientes" | "contactos" | etc
  onSelect, // callback opcional
  sourceFlag, // SOURCE_CLIENTE | SOURCE_CONTACTO
}) => {
  try {
    Swal.fire({
      title: "Buscando coincidencias...",
      text: "Por favor espere un momento",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const { data } = await api.post(baseUrl, queryParams);
    Swal.close();

    const records = data?.clients || data?.contacts || [];

    if (!records.length) return true;

    const uniqueRecords = Array.from(
      new Map(records.map((r) => [r.id, r])).values(),
    ).filter((r) => r.id !== currentId);

    const result = await showDuplicateContactsSwal({
      incomingUser: uniqueRecords,
      flags: data?.flag ?? [],
      origin: window.location.origin,
      incomingSite,
      onUseContact: (selected) => {
        if (onSelect) {
          onSelect(selected);
        } else if (setData && sourceFlag) {
          usarInformacionContacto(selected, sourceFlag, setData, null);
        }
      },
    });

    if (result.isConfirmed) {
      return data;
    }

    // return result.isConfirmed;
  } catch (error) {
    Swal.close();
    Swal.fire({
      title: "Error",
      text: "Ocurrió un error al buscar coincidencias.",
      icon: "error",
      confirmButtonColor: "#1ab394",
    });
    return false;
  }
};

export const hasImportantChanges = (current, original) =>
  current?.email !== original?.email ||
  current?.phone !== original?.phone ||
  current?.document !== original?.document;

export const hasNormalClientChanges = (current, original) =>
  current?.name !== original?.name ||
  current?.surname !== original?.surname ||
  current?.address !== original?.address ||
  current?.postalcode !== original?.postalcode ||
  // current?.observations !== original?.observations ||
  current?.province?.id_provincia !== original?.province?.id_provincia ||
  current?.company?.id !== original?.company?.id ||
  current?.document_type?.id !== original?.document_type?.id ||
  current?.association?.id !== original?.association?.id ||
  current?.zone?.id !== original?.zone?.id ||
  current?.status?.id !== original?.status?.id ||
  current?.office?.id !== original?.office?.id ||
  current?.lawyer?.id !== original?.lawyer?.id;

export const hasNormalContactChanges = (current, original) =>
  current?.name !== original?.name ||
  current?.surname !== original?.surname ||
  current?.address !== original?.address ||
  current?.postalcode !== original?.postalcode ||
  current?.observations !== original?.observations ||
  current?.email !== original?.email ||
  current?.phone !== original?.phone ||
  current?.nif !== original?.nif ||
  current?.marketing !== original?.marketing ||
  current?.date_in !== original?.date_in ||
  current?.province?.id_provincia !== original?.province?.id_provincia ||
  current?.company?.id !== original?.company?.id ||
  current?.document_type?.id !== original?.document_type?.id ||
  current?.asociation?.id !== original?.asociation?.id ||
  current?.cases_type?.id !== original?.cases_type?.id ||
  current?.status?.id !== original?.status?.id ||
  current?.lawyer?.id !== original?.lawyer?.id ||
  current?.assignTo?.id !== original?.assignTo?.id;
